import { Component, OnInit } from '@angular/core'
import { ChartType, ChartOptions } from 'chart.js'
import { Label } from 'ng2-charts'
import { Router } from '@angular/router'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { NotificationService } from '../../../services/notification.service'
import { CompanyService } from '../../../services/company.service'
import { DashboardService } from '../../../services/dashboard.service'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { Graphics } from 'src/app/models/Dashboard'
import * as moment from 'moment'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

	public graphics: Graphics = new Graphics()
	public sessionUser = getLoggedUser()
	public companyId: string = localStorage.getItem('companyId')
	public dateStart: string = moment().subtract(1, 'months').format('DD/MM/YYYY')
	public dateEnd: string = moment().format('DD/MM/YYYY')
	public ViewValidation: ViewValidation = new ViewValidation()

	public companyIsActive: boolean = false
	public loading: boolean = false
	public isLoading: boolean = false
	public hasPlantingOpportunity: boolean = false

	constructor(
		public notificationService: NotificationService,
		private dashboardService: DashboardService,
		private companyService: CompanyService,
		private router: Router
	) { }

	public ngOnInit(): void {
		this.isLoading = true

		this.dashboardService.getHasPlantingOpportunities(this.companyId).subscribe(
			(res: boolean) => {
				this.hasPlantingOpportunity = res
			},
			(err: any) => {
				this.notificationService.notify(err.error.message, err.error.code)
			}
		)

		const dateStart: string = moment().subtract(1, 'months').format('YYYY-MM-DD')

		const dateEnd: string = moment().format('YYYY-MM-DD')

		this.dashboardService.getGraphics(
			this.companyId,
			dateStart,
			dateEnd
		).subscribe((res: Graphics) => {
				this.graphics = res
				this.checkCompanyStatus()
				this.setDataGraphics()
				document.querySelector('main').className = ''
				this.isLoading = false
		})
	}

	public async checkCompanyStatus(): Promise<void> {
		try {
			const companyStatus: string =
				await this.companyService.checkStatus(this.companyId).toPromise()

			if (companyStatus === 'ACTIVE') {
				this.companyIsActive = true
			} else {
				this.companyIsActive = false
			}

		} catch (err) { }
	}

	public setDataGraphics(): void {
		/* Solicitações */
		this.pieSolicitationsLabels = this.graphics.solicitations.data.map(
			({ title: t }) => t
		)
		this.pieSolicitationsData = this.graphics.solicitations.data.map(
			({ value: v }) => v
		)

		/* Avaliações */
		this.pieEvaluationsLabels = this.graphics.evaluations.data.map(
			({ title: t }) => t
		)
		this.pieEvaluationsData = this.graphics.evaluations.data.map(
			({ value: v }) => v
		)

		/* Classes de Risco */
		this.pieRiskClassesLabels = this.graphics.riskClasses.data.map(
			({ title: t }) => t
		)
		this.pieRiskClassesData = this.graphics.riskClasses.data.map(
			({ value: v }) => v
		)

		/* Manejos */
		this.pieManagementsLabels = this.graphics.managements.data.map(
			({ title: t }) => t
		)
		this.pieManagementsData = this.graphics.managements.data.map(
			({ value: v }) => v
		)

		/* Oportunidades de Plantio */

		this.piePlantingData = this.graphics.plantingOpportunities.data.map(
			({ value: v }) => v
		)

		this.piePlantingLabels = this.graphics.managements.data.map(
			({ title: t }) => t
		)

		this.piePlantingTreeOriginSpecieInventoryData = this.graphics.plantingOriginSpeciesTreeInventaried.data.map(
			({ value: v }) => v
		)

		this.piePlantingSpecieInventoryData = this.graphics.plantingSpeciesTreeInventaried.data.map(
			({ value: v }) => v
		)

		this.piePlantingTreeOriginSpecieInventoryLabels = this.graphics.plantingOriginSpeciesTreeInventaried.data.map(
			({ title: t }) => t
		)

		this.piePlantingSpecieInventoryLabels = this.graphics.plantingSpeciesTreeInventaried.data.map(
			({ title: t }) => t
		)

		this.piePlantingSpecieInventorColors[0].backgroundColor = this.graphics.plantingSpeciesTreeInventaried.data.map(
			({ color }) => color
		)

		/* Classes de Manejos */
		this.pieManagementsClassesLabels = this.graphics.managementsClasses.data.map(
			({ title: t }) => t
		)
		this.pieManagementsClassesData = this.graphics.managementsClasses.data.map(
			({ value: v }) => v
		)
		/* Dap das árvores inventariadas */
		this.pieTreeDapInventoryLabels = this.graphics.dapTreeInventory.data.map(
			({ title: t }) => t
		)
		this.pieTreeDapInventoryData = this.graphics.dapTreeInventory.data.map(
			({ value: v }) => v
		)
		/* Altura das árvores inventariadas */
		this.pieTreeHeightInventoryLabels = this.graphics.heightTreeInventory.data.map(
			({ title: t }) => t
		)
		this.pieTreeHeightInventoryData = this.graphics.heightTreeInventory.data.map(
			({ value: v }) => v
		)

		/* origem das especies árvores inventariadas */
		this.pieTreeOriginSpecieInventoryLabels = this.graphics.originSpeciesTreeInventaried.data.map(
			({ title: t }) => t
		)
		this.pieTreeOriginSpecieInventoryData = this.graphics.originSpeciesTreeInventaried.data.map(
			({ value: v }) => v
		)

		/* especies inventariadas */

		this.pieSpecieInventoryLabels = this.graphics.speciesTreeInventaried.data.map(
			({ title: t }) => t
		)
		this.pieSpecieInventoryData = this.graphics.speciesTreeInventaried.data.map(
			({ value: v }) => v
		)

		this.pieSpecieInventorColors[0].backgroundColor = this.graphics.speciesTreeInventaried.data.map(
			({ color }) => color
		)
	}

	public async getDashboard(): Promise<void> {
		try {
			const dateStart = moment(this.dateStart, 'DD/MM/YYYY').format(
				'YYYY-MM-DD'
			)
			const dateEnd = moment(this.dateEnd, 'DD/MM/YYYY').format(
				'YYYY-MM-DD'
			)
			this.graphics =
				await this.dashboardService.getGraphics(this.companyId, dateStart, dateEnd).toPromise()

			this.setDataGraphics()
		} catch (err) { }
	}

	/* Graphics Pie Chart */
	public pieChartOptions: ChartOptions = {
		responsive: true,
		legend: {
			position: 'top'
		},

		plugins: {
			datalabels: {
				formatter: (value, ctx) => {
					const label = ctx.chart.data.labels[ctx.dataIndex]
					return label
				}
			}
		}
	}

	public pieChartType: ChartType = 'doughnut'
	public pieChartLegend: boolean = false


	public pieChartSpecieInventariedOptions: ChartOptions = {
		responsive: true,
		legend: {
			position: 'top'
		},
		scales: {
			yAxes: [{
				gridLines: {
					color: 'rgba(0, 0, 0, 0)'
				},
				ticks: {
					beginAtZero: true
				}
			}],
			xAxes: [{
				gridLines: {
					color: 'rgba(0, 0, 0, 0)'
				},
				ticks: {
					beginAtZero: true
				}
			}]
		},
		plugins: {
			datalabels: {
				formatter: (value, ctx) => {
					const label = ctx.chart.data.labels[ctx.dataIndex]
					return label
				}
			}
		}
	}

	/*******************************************************************
	 * Graphic - Solicitações
	 *******************************************************************/

	public pieSolicitationsLabels: Array<Label> = []
	public pieSolicitationsData: Array<number> = []
	public pieSolicitationsColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(234,37,5)',
				'rgb(137,148,129)'
			]
		}
	]

	/*******************************************************************
	 * Graphic - Solicitações
	 *******************************************************************/

	public pieEvaluationsLabels: Array<Label> = []
	public pieEvaluationsData: Array<number> = []
	public pieEvaluationsColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(234,37,5)',
				'rgb(137,148,129)'
			]
		}
	]

	/*******************************************************************
	 * Graphic - ÁRVORE POR DAP(INVENTÁRIO)
	 *******************************************************************/

	public pieTreeDapInventoryLabels: Array<Label> = []
	public pieTreeDapInventoryData: Array<number> = []
	public pieTreeDapInventorColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(225,146,54)',
				'rgb(234,37,5)'

			]
		}
	]

	/*******************************************************************
	 * Graphic - ÁRVORE POR ALTURAINVENTÁRIO)
	 *******************************************************************/

	public pieTreeHeightInventoryLabels: Array<Label> = []
	public pieTreeHeightInventoryData: Array<number> = []
	public pieTreeHeightInventorColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(225,146,54)',
				'rgb(234,37,5)'
			]
		}
	]


	/*******************************************************************
	* Graphic - ÁRVORE POR ORIGEM DE ESPÉCIE(INVENTÁRIO)
	*******************************************************************/

	public pieTreeOriginSpecieInventoryLabels: Array<Label> = []
	public pieTreeOriginSpecieInventoryData: Array<number> = []
	public pieTreeOriginSpecieInventorColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(234,37,5)'
			]
		}
	]

	/*******************************************************************
	 * Graphic - OPORTUNIDADE DE PLANTIO ( SPECIE )
	 *******************************************************************/

	public piePlantingTreeOriginSpecieInventoryData: Array<number> = []
	public piePlantingSpecieInventoryData: Array<number> = []

	public piePlantingTreeOriginSpecieInventoryLabels: Array<Label> = []
	public piePlantingTreeOriginSpecieInventorColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(234,37,5)'
			]
		}
	]

	public piePlantingSpecieInventoryLabels: Array<Label> = []
	public piePlantingSpecieInventorColors = [
		{
			backgroundColor: []
		}
	]

	/*******************************************************************
	 * Graphic - ÁRVORE POR ORIGEM DE ESPÉCIE(INVENTÁRIO)
	 *******************************************************************/

		public pieSpecieInventoryLabels: Array<Label> = []
		public pieSpecieInventoryData: Array<number> = []
		public pieSpecieInventorColors = [
			{
				backgroundColor: []
			}
		]


	/*******************************************************************
	 * Graphic - Classes de Risco
	 *******************************************************************/

	public pieRiskClassesLabels: Array<Label> = []
	public pieRiskClassesData: Array<number> = []
	public pieRiskClassesColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(225,146,54)',
				'rgb(234,37,5)'
			]
		}
	]

	/*******************************************************************
	 * Graphic - Manejo
	 *******************************************************************/

	public pieManagementsLabels: Array<Label> = [
		'REALIZADOS',
		'PENDENTES',
		'ATRASADOS',
		'CANCELADOS'
	]
	public pieManagementsData: Array<number> = [632, 249, 121, 150]
	public pieManagementsColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(234,37,5)',
				'rgb(137,148,129)'
			]
		}
	]

	/*******************************************************************
	 * Graphic - Classes de Risco
	 *******************************************************************/

	public piePlantingLabels: Array<Label> = [
		'REALIZADOS',
		'PENDENTES',
		'ATRASADOS',
		'CANCELADOS'
	]

	public piePlantingData: Array<number> = [632, 249, 121, 150]

	public piePlantingColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(234,37,5)',
				'rgb(137,148,129)'
			]
		}
	]

	/*******************************************************************
	 * Graphic - Manejo
	 *******************************************************************/

	public pieManagementsClassesLabels: Array<Label> = [
		'PREVENTIVO',
		'PREDITIVO',
		'CORRETIVO',
		'INTENSIVO',
		'SUPRESSÃO'
	]
	public pieManagementsClassesData: Array<number> = [632, 249, 121, 150, 90]
	public pieManagementsClassesColors = [
		{
			backgroundColor: [
				'rgb(106,162,7)',
				'rgb(249,220,71)',
				'rgb(225,146,54)',
				'rgb(234,37,5)',
				'rgb(137,148,129)'
			]
		}
	]

	public redirectToTreesComponent() {
		console.log('Inactive')
	}

	public redirectToDemands(event) {
		if (
			event.active[0]._view && event.active[0]._view.label === 'PENDENTES' ||
			event.active[0]._view.label === 'ATRASADAS' || event.active[0]._view.label === 'CANCELADAS'
		) {
			this.router.navigate(['/panel/scheduler'])
		} else if (
			event.active[0]._view && event.active[0]._view.label === 'ATENDIDAS' ||
			event.active[0]._view.label === 'REALIZADAS'
		) {
			this.router.navigate(['/panel/demandsHistory'])
		}
	}

	public redirectToHistoryInventory() {
		this.router.navigate(['/panel/historyInventory'])
	}

	public redirectToHistoryPlanting() {
		this.router.navigate(['/panel/planting/history-planting'])
	}

	public redirectToPlanting(event) {
		if (
			event.active[0]._view && event.active[0]._view.label === 'PENDENTES' ||
			event.active[0]._view.label === 'ATRASADAS' || event.active[0]._view.label === 'CANCELADAS'
		) {
			this.router.navigate(['/panel/planting/scheduler-planting'])
		} else if (
			event.active[0]._view && event.active[0]._view.label === 'ATENDIDAS' ||
			event.active[0]._view.label === 'REALIZADAS'
		) {
			this.router.navigate(['/panel/planting/history-planting'])
		}
	}
}
